module.exports = __webpack_public_path__ + "static/media/029.f2a8cd7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/029.jpg
// module id = 502
// module chunks = 0